import { useState } from 'react';
import styled from 'styled-components';
import { Loading, FlexColumn } from '@elementary/common-ui/components';
import { space } from '@elementary/common-ui/style/utils';
import { useRoles } from '../../shared/useRoles';
import Header from './Header';
import RolesTable from './RolesTable';

const Wrapper = styled(FlexColumn)`
  height: 100%;
  width: 100%;
  gap: ${space('xxl')};
`;

const Roles = () => {
  const [search, setSearch] = useState('');
  const { roles, isLoading, deleteRoleAsync, isDeleting } = useRoles();

  return isLoading ? (
    <Loading />
  ) : (
    <Wrapper>
      <Header search={search} onSearchChange={setSearch} />

      <RolesTable
        roles={roles}
        search={search}
        onDeleteRole={deleteRoleAsync}
        isDeleting={isDeleting}
      />
    </Wrapper>
  );
};

export default Roles;
